import { defaultTheme } from 'constants/theme/defaultTheme';
import styled from 'styled-components';
import { breakpoints } from 'stylesheet';
import { GridContainer } from 'components/Grid/Grid';

const spaceAtTop = defaultTheme.spacing(15);

export const Styles = {
  GridContainer: styled(GridContainer)`
    grid-template-rows: min-content 1fr;

    @media (min-width: ${breakpoints.small}) {
      grid-template-rows: 1fr;
    }
  `,
  BackButton: styled.button`
    display: none;
    border: none;

    @media (min-width: ${breakpoints.small}) {
      height: ${spaceAtTop};
      display: flex;
      cursor: pointer;
      flex-direction: row;
      background-color: transparent;
      align-items: center;
      justify-content: flex-start;
      padding: ${defaultTheme.spacing(2)} 0 ${defaultTheme.spacing(8)};
    }
  `,
  BackArrow: styled.span`
    transform: rotate(180deg);
    height: 30px;
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  MainContent: styled.main`
    height: 100%;
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    padding: 0 ${defaultTheme.spacing(4)};
  `,
  MainContentHeader: styled.div`
    padding-top: ${defaultTheme.spacing(7)};
    padding-bottom: ${defaultTheme.spacing(5)};

    @media (min-width: ${breakpoints.small}) {
      padding-top: ${spaceAtTop};
    }
  `,
  Sidebar: styled.div`
    @media (min-width: ${breakpoints.small}) {
      position: sticky;
      display: flex;
      top: 61px;
      width: 100%;
      height: calc(100vh - 61px);
    }
  `,
  SideBarContent: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;

    @media (min-width: ${breakpoints.small}) {
      padding: 0 ${defaultTheme.spacing(2)};
    }
  `,
  SideBarFilters: styled.div`
    display: none;
    overflow: auto;
    padding-right: ${defaultTheme.spacing(2)};

    @media (min-width: ${breakpoints.small}) {
      display: block;
    }
  `,
  SideBarFixedHeading: styled.div<{ isBorder: boolean }>`
    width: 100%;
    ${props => props.isBorder && `border-bottom: 1px solid ${defaultTheme.colors.separator};`}
    padding: ${defaultTheme.spacing(6)} ${defaultTheme.spacing(4)};

    @media (min-width: ${breakpoints.small}) {
      padding: 0;
      padding-bottom: ${defaultTheme.spacing(7)};
    }
  `,
};
